
//greensock

var controller = new ScrollMagic.Controller();


	// loop through all elements
	jQuery('.block').each(function() {

		// build a tween
		var tween = TweenMax.from(jQuery(this), 1, {autoAlpha: 0, y: 20, ease: Power2.easeOut});

		// build a scene
		var scene = new ScrollMagic.Scene({
			triggerElement: this,
			triggerHook: 'onEnter', offset: 200
		})
		.setTween(tween) // trigger a TweenMax.to tween
		.addTo(controller);

	});




//swiperJS (carousel)

var galleryThumbs = new Swiper('.gallery-thumbs', {
  spaceBetween: 10,
  slidesPerView: 3,
  loop: true,
  freeMode: true,
  loopedSlides: 3, //looped slides should be the same
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});

var galleryTop = new Swiper('.gallery-top', {
  spaceBetween: 10,
  loop:true,
  zoom: true,
  loopedSlides: 3, //looped slides should be the same
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: galleryThumbs,
  },
});


var swiper = new Swiper('.swiper-container-cover-1col-bg', {
  slidesPerView: 1,
  centeredSlides: true,
  autoplay: {
    delay: 7000,
  },
  loop: true,
  speed: 1000,
  pagination: {
  el: '.swiper-pagination',
  clickable: true,
  },
});

var swiper = new Swiper('.swiper-container-block-3col-swiper', {
  slidesPerView: 3,
  spaceBetween: 15,
  loop: true,
  speed: 800,

  breakpoints: {
    // when window width is >= 480px
    480: {
      slidesPerView: 1,
      spaceBetween: 15
    },
    // when window width is >= 780px
    780: {
      slidesPerView: 3,
      spaceBetween: 15
    },
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

var swiper = new Swiper('.swiper-container-logo-swiper', {
  slidesPerView: 4,
  spaceBetween: 30,
  slidesPerColumn: 1,
  speed: 2000,
  freeMode: true,
  loop: true,
  loopFillGroupWithBlank: true,
  autoplay: {
  delay: 0,
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
      spaceBetween: 30,
      slidesPerColumn: 1,
      speed: 2000,
      freeMode: true,
      loop: true,
      loopFillGroupWithBlank: true,
      autoplay: {
      delay: 0,
      },
    },
    // when window width is >= 780px
    780: {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesPerColumn: 1,
      speed: 2000,
      freeMode: true,
      loop: true,
      loopFillGroupWithBlank: true,
      autoplay: {
      delay: 0,
      },
    },
  },

});

var swiper = new Swiper('.swiper-container-testimonial-swiper', {
  slidesPerView: 1,
  loop: true,
  speed: 800,
  autoplay: {
  delay: 5000,
  },
  pagination: {
  el: '.swiper-pagination',
  clickable: true,
  },
});


var swiper_culture = new Swiper('.swiper-container-culture-swiper', {
  slidesPerView: 1,
  loop: true,
  speed: 800,

  // Navigation arrows
  navigation: {
    prevEl: '.next-button',
  },

  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }

});

// if(!Modernizr.touch){
// 	myParaxify = paraxify('.paraxify');
// }
